<template>
  <div class="text-center mb-5" id="topico-pdf-container">
    <iframe :src="pdfUrl" width="100%" height="1000vh">
      <p>Aparentemente seu navegador não possui o Adobe Reader ou suporte a PDF. <a :href="pdfUrl" target="_blank">Faça o download do PDF</a> ou <a href="http://get.adobe.com/reader/" target="_blank">clique aqui para instalar o Adobe Reader.</a></p>
    </iframe>
    <div class="mt-4">Problemas ao visualizar o PDF? <a :href="pdfUrl" target="_blank">Clique aqui</a></div>
  </div>
</template>

<script>
import ImageUtils from '@/core/utils/image-utils'

export default {
  name: 'TopicoPdf',
  props: {
    ementaCurso: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      pdfUrl: ''
    }
  },
  methods: {
    obterTopico: function () {
      this.pdfUrl = ImageUtils.obterUrlCompletaImagem(this.ementaCurso.topico_escolhido.url)
    }
  },
  mounted () {
    this.obterTopico()
  },
  watch: {
    ementaCurso: function () {
      this.obterTopico()
    }
  }
}
</script>

<style scoped>
  .resp-container {
    position: relative;
    overflow: hidden;
    padding-top: 56.25%;
  }

  .resp-pdf {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
</style>
